import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import { VDateInput } from 'vuetify/labs/VDateInput';

import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import thumbsUp from '/icons/thumbs-up.svg';
import thumbsDown from '/icons/thumbs-down.svg';
import thumbsUpDown from '/icons/thumbs-up-down.svg';

const lightTheme = {
  dark: false,
  colors: {
    'primary-blue': '#5171FF',
    'secondary-blue': '#00BCD4',
    'primary-black': '#212121',
    // 'primary-blue': '#5171FF',
    // 'primary-teal': '#00BCD4',
    // 'primary-black': '#212121',
    // 'dark-blue': '#000d46',
    primary: '#5171FF',
    secondary: '#5CE1E6',
    purple: '#8C52FF',
    black: '#212121',
    success: '#7ED957',
    warning: '#FFA300',
    error: '#E86267'
  }
};

const darkTheme = {
  dark: true,
  colors: {
    primary: '#d35400',
    secondary: '#8e44ad',
    background: '#2f3640',
    error: '#c0392b',
    info: '#2980b9',
    success: '#27ae60',
    warning: '#f1c40f'
  }
};

export default createVuetify({
  // theme: false,
  components: {
    VDateInput,
    ...components
  },
  // components,
  directives,
  icons: {
    defaultSet: 'mdi',
    values: {
      thumbsUp: {
        // name of our custom icon
        component: thumbsUp // our custom component
      }
    }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: lightTheme,
      dark: darkTheme
    }
  },
  defaults: {
    VChip: {},
    VBtn: {
      // variant: 'flat',
      // height: '40',
      // class: ['text-capitalize', 'font-weight-medium'],
      // style: 'border-radius: 4px !important'
    },
    VTextField: {
      style: 'border-radius: 10px !important',
      height: '40',
      // class: ['text-capitalize', 'font-weight-medium']
      density: 'compact'
    },
    VList: {
      density: 'compact'
    },
    VListItem: {
      density: 'compact'
    },
    VListItemTitle: {
      style: 'font-size:0.875rem'
    },
    VSelect: {
      style: 'height: 35px'
    },
    VDivider: {
      opacity: 1
    }
  }
});
